import { messagesReducer } from './messages.reducer';
import * as messagesActions from './messages.actions';
import MessagesComponent from './messages';
import AllMessagesComponent from './all-messages.component';

export {
  messagesReducer,
  messagesActions,
  MessagesComponent,
  AllMessagesComponent
}



// WEBPACK FOOTER //
// src/dashboard/messages/index.js